module.exports = __webpack_public_path__ + "static/media/logo_h.97b948dd.svg";